import { gql } from "generated-graphql";

/**
 * The fleet-wide expired-alternate-id review queue. Staff-only and tenant-less:
 * one backlog worked in one place.
 */
export const EXPIRED_ALT_ID_MATCH_REVIEWS = gql(`
  query ExpiredAltIdMatchReviews(
    $search: String
    $pendingOnly: Boolean
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    expiredAltIdMatchReviews(
      search: $search
      pendingOnly: $pendingOnly
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      count
      items {
        id
        tenantId
        tenantName
        facilityId
        facilityName
        matchKind
        altIdValue
        alternateIds {
          id
          type
          expiresAt
        }
        violationCount
        earliestViolationStartDate
        latestViolationStartDate
        activeElsewhere
        firstSeenAt
        acceptedAt
        acceptedByName
      }
    }
  }
`);

export const SET_EXPIRED_ALT_ID_MATCH_ACCEPTED = gql(`
  mutation SetExpiredAltIdMatchAccepted($id: ID!, $accepted: Boolean!) {
    setExpiredAltIdMatchAccepted(id: $id, accepted: $accepted) {
      id
      acceptedAt
      acceptedByName
    }
  }
`);

/**
 * Count of this tenant's violations held on an unaccepted group, for the
 * staff-only pointer on the customer Violations grid. Its own read rather than a
 * field on the stats query, which carries the user's live omnisearch filter.
 */
export const HELD_HARMONIZED_VIOLATION_COUNT = gql(`
  query HeldHarmonizedViolationCount($tenantId: ID!) {
    heldHarmonizedViolationCount(tenantId: $tenantId)
  }
`);

/**
 * Held groups for one facility, for screens that are about to make an alternate
 * ID active. Reachable by customers as well as staff — they need opposite
 * warnings about the same fact.
 */
export const HELD_EXPIRED_ALT_ID_MATCHES_FOR_FACILITY = gql(`
  query HeldExpiredAltIdMatchesForFacility($facilityId: ID!) {
    heldExpiredAltIdMatchesForFacility(facilityId: $facilityId) {
      id
      altIdValue
      matchKind
      violationCount
    }
  }
`);

/**
 * The violations held against one group, fetched only when the review drawer
 * opens — a group can hold dozens and the queue needs none of them.
 */
export const EXPIRED_ALT_ID_MATCH_VIOLATIONS = gql(`
  query ExpiredAltIdMatchViolations($id: ID!) {
    expiredAltIdMatchViolations(id: $id) {
      id
      violationId
      sourceProgram
      standardizedSeverity
      standardizedResolutionStatus
      violationDescription
      violationStartDate
      violationEndDate
      facilityName
    }
  }
`);
